import { createContext, useContext } from 'react';

/**
 * Shares the "open the assistant" action from MainLayout (which owns the panel
 * open state) with descendants that live outside the launcher — notably the
 * avatar ProfileMenu, which surfaces the assistant as a menu item on mobile in
 * place of the floating action button.
 *
 * `seed` opens the drawer with a message that auto-sends once the chat is
 * hydrated and idle (the dashboard's "set up your invitation" nudge). It is a
 * plain visible user message — same semantics as tapping a suggestion chip.
 *
 * Null when consumed outside a provider (e.g. ProfileMenu rendered in isolation)
 * — consumers guard on this and simply omit the entry point.
 */
interface AssistantContextValue {
  openAssistant: (options?: { seed?: string }) => void;
}

export const AssistantContext = createContext<AssistantContextValue | null>(null);

export const useAssistant = () => useContext(AssistantContext);
